import { UseQueryModalReturn } from "types";

interface UseTextOrMultiQueryModalParams {
  mode: "text" | "multiple";
  selectedItems: any[];
  previousItems: any[];
  searchText: string;
  previousText: string;
  selectedOperator?: any | null;
  previousOperator?: any | null;
  initialOperator?: any | null;
  editQueryId?: string;
  existingQueryId?: string | null;
  resetSearchText?: () => void;
  resetSelectedItems?: (updater: (prev: any[]) => any[]) => void;
}

function areArraysEqual(arr1: string[], arr2: string[]): boolean {
  if (arr1.length !== arr2.length) return false;

  const sorted1 = [...arr1].sort();
  const sorted2 = [...arr2].sort();

  return sorted1.every((val, i) => val === sorted2[i]);
}

export function useTextOrMultiQueryModal({
  mode,
  selectedItems,
  previousItems,
  searchText,
  previousText,
  selectedOperator,
  previousOperator,
  editQueryId,
  existingQueryId,
}: UseTextOrMultiQueryModalParams): UseQueryModalReturn {
  const isMultiple = mode === "multiple";

  const isSubmitDisabled = (() => {
    if (editQueryId) {
      if (isMultiple) {
        return (
          areArraysEqual(selectedItems, previousItems) &&
          selectedOperator === previousOperator
        );
      } else {
        if (selectedOperator !== previousOperator) {
          return searchText.length === 0;
        } else {
          return searchText === previousText;
        }
      }
    }

    if (existingQueryId) {
      return isMultiple
        ? areArraysEqual(selectedItems, previousItems)
        : searchText.length === 0 || searchText === previousText;
    }

    return isMultiple ? selectedItems.length === 0 : searchText.length === 0;
  })();

  return { isSubmitDisabled };
}
